import { TextBox } from 'devextreme-react/text-box';
import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { Button, Card, Col, Collapse, Input, Label, Row } from 'reactstrap';
import Swal from 'sweetalert2';
import erorSound from '../../assets/audio/alert-error.wav';
import Breadcrumb from '../../components/common/breadcrumb';
import api from '../../services/api-configuration';
import useFormatMessage from '../../utils/useFormatMessage';
import { getPersonKontrolByGrupajNo } from '../peron-kontrol/api';

import DataGrid, { Column } from 'devextreme-react/data-grid';

const markChassisTruckScanned = async (data) => {
    try {
        const response = await api.post('/markChassisTruckScanned', data);

        return response.data;
    } catch (error) {

        return { success: false, error: error.response.data.error || "" };
    }
};
const approveGroupageTruck = async (groupageNo) => {

    try {
        const response = await api.post('/approveGroupageTruck', { groupage_no: groupageNo });
        return response.data;
    }
    catch (error) {
        return { success: false, error: error.response.data.error || "" };
    }
};
// Shared barcode scanner hook
const useBarcodeScanner = (onBarcodeScanned) => {
    const [buffer, setBuffer] = useState("");
    const timeoutRef = useRef(null);

    useEffect(() => {
        const handleKeyDown = (e) => {
            // Prevent handling if focus is on an input
            if (e.target.tagName === 'INPUT') return;

            if (e.key === "Enter") {
                // Barcode scanner finished sending data
                if (buffer) {
                    onBarcodeScanned(buffer);
                    setBuffer("");
                }
            } else if (e.key && e.key.length === 1) {
                // Reset buffer if too much time has passed (manual typing vs scanner)
                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                }

                setBuffer(prev => prev + e.key);

                // Clear buffer after 50ms of no input (barcode scanners are typically very fast)
                timeoutRef.current = setTimeout(() => {
                    setBuffer("");
                }, 50);
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [buffer, onBarcodeScanned]);
};

// Shared alert functions
const showSuccess = (message) => {
    Swal.fire({
        title: '<div class="text-green-600">Başarılı</div>',
        html: `<div class="text-gray-700">${message}</div>`,
        icon: 'success',
        timer: 3000,
        timerProgressBar: true,
        showConfirmButton: false
    });
};

const showError = (message) => {
    Swal.fire({
        title: '<div class="text-red-600">Hata</div>',
        html: `<div class="text-gray-700" style="background: #ffc9c9; font-weight: 700;color: #000000;padding: 20px;border-radius: 10px;">${message}</div>`,
        icon: 'error',
        timerProgressBar: true,
        showConfirmButton: false,
        showCancelButton: true,
        allowOutsideClick: false,
        cancelButtonText: 'TAMAM'
    });
};

// API functions
const exitWithChassis = async (chassisNo, groupageNo) => {
    try {
        const response = await api.post('/exitWithChassis', {
            chassis_no: chassisNo,
            groupage_no: groupageNo
        });
        return response.data;
    } catch (error) {
        return { success: false, error: error.response.data.error || "" };
    }
};

const exitWithGroupage = async (groupageNo) => {
    try {
        const response = await api.post('/exitWithGroupage', { groupage_no: groupageNo });
        return response.data;
    } catch (error) {
        return { success: false, error: error.response.data.error || "" };
    }
};
// TruckApproval Component
export const TruckApproval = () => {
    const { t } = useFormatMessage();
    const [dataSource, setDataSource] = useState([]);
    const [scannedSase, setScannedSase] = useState(new Set());
    const [barcode, setBarcode] = useState("");
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [lastScanTime, setLastScanTime] = useState(0);
    const [isOpen, setIsOpen] = useState(false);
    const SCAN_DELAY = 100;

    const swalConfig = {
        customClass: {
            container: 'custom-swal-container',
            popup: 'custom-swal-popup',
            title: 'custom-swal-title',
            confirmButton: 'custom-swal-confirm-button',
            cancelButton: 'custom-swal-cancel-button'
        },
        buttonsStyling: false,
        confirmButtonText: 'Tamam',
        background: '#ffffff',
        showCloseButton: true,
        width: 'auto',
        padding: '2rem'
    };

    const playErrorAlert = () => {
        if (navigator.vibrate) {
            navigator.vibrate(500);
        }
        const errorSound = document.getElementById("errorSound");
        errorSound.play();
    };

    const showErrorWithTimer = (title, message, details = '') => {
        Swal.fire({
            // title: `<div class="text-red-600">
            // ⚠️ ${title.toUpperCase()} 
            // </div>`,
            html: `<div class="text-gray-700"
            style="
            text-transform: capitalize;
            background: #ffbbbb;
            padding: 10px 20px;
            /* color: red; */
            border-radius: 10px;
            font-size: 17px;
            font-weight: 600;
    "
            >
                <p>${message}</p>
                ${details ? `<div class="mt-2">${details}</div>` : ''}
            </div>`,
            icon: 'warning',
            // timer: 4000,
            timerProgressBar: true,
            showConfirmButton: false,
            background: '#ffffff',
            customClass: {
                popup: 'custom-swal-popup',
                title: 'custom-swal-title',
            },
        });
    };

    const showSuccessWithTimer = (title, message, size) => {
        Swal.fire({
            title: `<div class="text-green-600">${title}</div>`,
            html: `<div class="text-gray-700">
                <p>${message}</p>
                ${size ? `<h4 class="font-weight-bold mt-2">${size}</h4>` : ''}
            </div>`,
            icon: 'success',
            timer: 3000,
            timerProgressBar: true,
            showConfirmButton: false,
            background: '#ffffff',
            customClass: {
                popup: 'custom-swal-popup',
                title: 'custom-swal-title',
            },
        });
    };

    const handleGrupajScan = async (grupajNo) => {
        try {
            const response = await getPersonKontrolByGrupajNo(grupajNo);
            if (response.success && response.details) {
                const transformedData = response.details.map((item, index) => ({
                    id: index + 1,
                    Durum: item.is_truck_scanned ? "Okundu" : "",
                    Sase: item.chassis_no,
                    Model: `${item.brand} ${item.model}`,
                    Renk: item.color,
                    Peron: item.platform_info,
                    is_truck_scanned: item.is_truck_scanned,
                    is_scanned: item.is_scanned
                }));

                const initialScanned = new Set(
                    response.details
                        .filter(item => item.is_truck_scanned)
                        .map(item => item.chassis_no)
                );
                setDataSource(transformedData);
                setScannedSase(initialScanned);

                if (initialScanned.size === response.details.length) {
                    showSuccessWithTimer(
                        'Tüm Şaseler Okundu',
                        'Tüm şaseler başarıyla tarandı!',
                        `${initialScanned.size}/${response.details.length}`
                    );
                }
            } else {
                let error_message = response.error ? response.error : "Hata";
                showErrorWithTimer('Uyarı', t(error_message));
            }
        } catch (error) {
            console.error("Grupaj No verisi alınırken hata:", error);
            setDataSource([]);
        }
    };

    const updateScannedChassis = (chassisNo) => {
        setDataSource(prev => prev.map(item => {
            if (item.Sase === chassisNo) {
                return { ...item, is_truck_scanned: true, Durum: "Okundu" };
            }
            return item;
        }));

        setScannedSase(prev => {
            const updated = new Set(prev).add(chassisNo);
            if (updated.size === dataSource.length) {
                showSuccessWithTimer(
                    'Başarılı',
                    'Tüm şaseler başarıyla tamamlandı!',
                    `${updated.size}/${dataSource.length}`
                );
            }
            return updated;
        });
    };

    const handleChassisScanned = async (chassisNo) => {
        const matchingSase = dataSource.find(item => item.Sase === chassisNo);

        if (!matchingSase) {
            playErrorAlert();
            showErrorWithTimer(
                'Uyarı',
                `Şase ${chassisNo} belirtilen grupaja dahil değildir.`
            );
            return;
        }

        if (scannedSase.has(chassisNo)) {
            playErrorAlert();
            showErrorWithTimer(
                'Uyarı',
                `Şase ${chassisNo} daha önce okutulmuştur.`
            );
            return;
        }

        try {
            const response = await markChassisTruckScanned({
                chassis_no: chassisNo,
                groupage_no: barcode
            });

            if (response.success) {
                updateScannedChassis(chassisNo);
                // showSuccessWithTimer(
                //     'Başarılı',
                //     'Şase başarıyla kaydedildi'
                // );
                toast.success('Şase başarıyla kaydedildi', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            } else {
                playErrorAlert();
                showErrorWithTimer(
                    'Uyarı',
                    response.error
                );
            }
        } catch (error) {
            console.error("Şase kaydedilirken hata:", error);
            playErrorAlert();
            let message = error.response?.data?.error || "İşlem sırasında bir hata oluştu";
            showError("Hata" + message);
            showErrorWithTimer(
                'Hata',
                'HATA' + message
            );
        }
    };

    const handleKeyPress = async (e) => {
        const key = e.key?.trim();
        let invalidSase = document.getElementById('sase_okut') ? document.getElementById('sase_okut').value : "";
        if (key === 'Enter') {
            if (dataSource.length === 0) {
                handleGrupajScan(barcode);
            } else {
                await handleChassisScanned(invalidSase);
                if (document.getElementById('sase_okut')) {
                    document.getElementById('sase_okut').value = "";
                }
            }
        }
    };

    const handleApproveGroupage = async () => {
        // Check if at least one truck is scanned
        if (scannedSase.size === 0) {
            showErrorWithTimer(
                'Uyarı',
                'En az bir şase okutulmuş olmalıdır.',
                'Onaylama işlemi için lütfen en az bir şase okutunuz.'
            );
            return;
        }

        if (scannedSase.size !== dataSource.length) {
            const missingSase = dataSource.filter(item => !scannedSase.has(item.Sase));
            Swal.fire({
                html: `<div style="line-height: 1.4; color: #555;">
                    Aşağıdaki şase numaraları eksik:<br/><br/>
                    <ul style="padding-left: 20px;">
                    ${missingSase.map(item => `<li style="color: #007bff;">${item.Sase}</li>`).join('')}
                    </ul><br/><strong>İşlemi onaylıyor musunuz?</strong>
                    </div>`,
                showCancelButton: true,
                confirmButtonText: t("Evet"),
                cancelButtonText: t("Hayır"),
                background: '#ffffff',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await finalizeApproval();
                }
            });
        } else {
            await finalizeApproval();
        }
    };
    const finalizeApproval = async () => {
        try {
            const response = await approveGroupageTruck(barcode);
            if (response.success) {
                showSuccessWithTimer('Onaylandı', 'İşlem başarıyla tamamlandı');
                setTimeout(() => {
                    setDataSource([]);
                    setBarcode("");
                    setScannedSase(new Set());
                }, 1000);
            } else {
                showErrorWithTimer('Hata', response.error || 'İşlem başarısız oldu');
            }
        } catch (error) {
            let message = error.response?.data?.error || "İşlem sırasında bir hata oluştu";

            showErrorWithTimer('Hata', 'HATA' + message);
        }
    };

    useEffect(() => {

        window.addEventListener('keydown', handleKeyPress);
        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        };
    }, [dataSource, barcode]);

    const gridOptions = {
        columnHidingEnabled: true,
        columnMinWidth: isMobile ? 120 : 'auto',
        width: '100%',
        showBorders: true,
        showRowLines: true,
        showColumnLines: true,
        columnResizingMode: 'widget',
        allowColumnResizing: true,
        scrolling: {
            mode: isMobile ? 'standard' : 'virtual',
            showScrollbar: 'always'
        }
    };

    return (
        <>
            <Breadcrumb current={t("Tır Onay (aktif değil)")} />
            <audio id="errorSound" src={erorSound} preload="auto"></audio>
            <Card className='p-2'>
                <Row className='m-2 space-y-4'>
                    <Col md="4">
                        <Label style={{ fontWeight: "600" }} className="block text-sm font-medium mb-2">
                            {t("GrupajNo")}
                        </Label>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div className="input-group pill-input-group"
                                style={{
                                    display: "grid",
                                    gridTemplateColumns: "5fr 1fr"
                                }}
                            >
                                <TextBox
                                    showClearButton={true}
                                    value={barcode}
                                    onValueChanged={(e) => {
                                        setBarcode(e.value);
                                        if (!e.value) {
                                            setDataSource([]);
                                            setScannedSase(new Set());
                                        }
                                    }}
                                    placeholder={t("Grupaj No Giriniz") + "..."}
                                    id='grupajNo'
                                />
                                <div className="input-group-append">
                                    <Button
                                        color='info'
                                        onClick={() => handleGrupajScan(barcode)}
                                        style={{ padding: "8px 12px" }}>
                                        <i className='fa fa-search'></i>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>

                {dataSource.length > 0 && (
                    <>
                        <Row className='m-2'>
                            <Col md="4" className='flex justify-between items-center mb-2'>
                                <Label className='text-sm font-medium' style={{ fontWeight: "600", display: "flex", justifyContent: "space-between" }}>
                                    <span>{t("Şase")}</span>
                                    <span className={`text-sm font-medium ${scannedSase.size === dataSource.length
                                        ? 'text-green-600'
                                        : 'text-red-600'
                                        }`}
                                        style={{
                                            color: scannedSase.size === dataSource.length ? '#28a745' : '#dc3545'
                                        }}
                                    >
                                        {scannedSase.size} / {dataSource.length}
                                    </span>
                                </Label>
                                <Input
                                    id='sase_okut'
                                    className="form-control input-sm text-box single-line w-full"
                                    placeholder={t("Şase Okutunuz") + "..."}
                                />
                            </Col>
                        </Row>

                        <Row className='mx-1 mx-md-2 mt-4'>
                            <Col xs="12" md="12" lg="8">
                                <p onClick={() => setIsOpen(!isOpen)}
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "end",
                                        fontWeight: "600"
                                    }}
                                >
                                    <span>
                                        {dataSource[0].Peron}
                                    </span>
                                    <span style={{
                                        cursor: "pointer"
                                    }}>
                                        {t("DETAY")} <i className={`fa fa-chevron-${isOpen ? "up" : "down"}
                                         cursor-pointer`} ></i>
                                    </span>
                                </p>

                                <Collapse isOpen={!isOpen}>
                                    <DataGrid
                                        width={"auto"}
                                        {...gridOptions}
                                        showBorders={true}
                                        showRowLines={true}
                                        showColumnLines={true}
                                        dataSource={dataSource}
                                        onRowPrepared={(e) => {
                                            if (e.rowType === 'data') {
                                                if (e.data.is_truck_scanned === true) {
                                                    e.rowElement.style.backgroundColor = '#f0f0f0';
                                                    e.rowElement.classList.add('scanned-row');
                                                }
                                            }
                                        }}
                                    >
                                        <Column
                                            dataField="Sase"
                                            caption={t("Şase")}
                                            width={isMobile ? 159 : undefined}
                                        />
                                        {/* <Column
                                            dataField="Model"
                                            caption={t("Model")}
                                            width={isMobile ? 140 : undefined}
                                        /> */}
                                        <Column caption={t("Peron OnayI")} dataField="is_scanned"
                                            width={isMobile ? 140 : undefined}
                                            dataType='string'
                                            calculateDisplayValue={(data) => {
                                                console.log(data);
                                                if (data.is_scanned === true) return "ONAYLANDI";
                                                return "BEKLİYOR";
                                            }}
                                        >

                                        </Column>
                                    </DataGrid>
                                </Collapse>

                                <Collapse
                                    isOpen={isOpen}
                                    className="overflow-hidden"
                                >
                                    {dataSource.length > 0 && (
                                        <div className="space-y-1">
                                            {dataSource.map((item) => (
                                                <div
                                                    key={item.id}
                                                    style={{
                                                        backgroundColor: item.is_truck_scanned ? "#f0f0f0" : "white"
                                                    }}
                                                    className={`p-2 rounded-md border`}
                                                >
                                                    <div className="grid grid-cols-3 text-sm gap-x-2">
                                                        <div className="col-span-3 font-medium truncate">
                                                            <b>{item.Sase}</b>
                                                        </div>
                                                        <div className="truncate">{item.Model} - {item.Renk}</div>
                                                        <div className="truncate">{item.Peron}</div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </Collapse>
                            </Col>

                            <Col xs="12" md="12" lg="5" className="mt-4 mt-lg-0 mt-2"
                                style={{
                                    display: "flex",
                                    justifyContent: "end",
                                }}
                            >
                                <Button
                                    color="success"
                                    className="w-100"
                                    onClick={handleApproveGroupage}
                                    disabled={dataSource.length === 0}
                                >
                                    {t("Onayla")}
                                </Button>
                            </Col>
                        </Row>
                    </>
                )}
            </Card>
        </>
    );
};

const processDealerReturn = async (chassisNo) => {
    const body = {
        chassis_no: chassisNo,
        warehouse_id: localStorage.getItem("warehouse") ?
            parseInt(Buffer.from(localStorage.getItem("warehouse"), 'base64').toString('ascii')) :
            null
    };
    try {
        const response = await api.post('/processDealerReturn', body);
        return response.data;
    } catch (error) {
        return { success: false, error: error.response.data.error || "" };
    }
};

// ChassisExit Component
export const ChassisExit = () => {
    const { t } = useFormatMessage();
    const [grupajNo, setGrupajNo] = useState("");
    const [chassisNo, setChassisNo] = useState("");
    const [isProcessing, setIsProcessing] = useState(false);

    const handleBarcodeScanned = (scannedValue) => {
        setIsProcessing(true);
        if (!grupajNo) {
            setGrupajNo(scannedValue);
            //showSuccess(t("Grupaj No Kaydedildi"));
        } else if (!chassisNo) {
            setChassisNo(scannedValue);
            handleExit(scannedValue, grupajNo);
        }
        setIsProcessing(false);
    };

    useBarcodeScanner(handleBarcodeScanned);

    const handleExit = async (chassis = chassisNo, grupaj = grupajNo) => {
        if (!grupaj || !chassis) return;

        setIsProcessing(true);
        try {
            const response = await exitWithChassis(chassis, grupaj);
            if (response.success) {
                showSuccess(t("Şase çıkışı başarıyla yapıldı"));
                setChassisNo("");
                setGrupajNo("");
            } else {
                showError(t(response.error || "İşlem başarısız"));
            }
        } catch (error) {
            let message = error.response?.data?.error || "İşlem sırasında bir hata oluştu";
            showError("Hata" + message);
        } finally {
            setIsProcessing(false);
        }
    };

    const handleKeyDown = (e, field) => {
        if (e.key === 'Enter') {
            const value = e.target.value;
            if (field === 'grupaj' && !grupajNo) {
                setGrupajNo(value);
                showSuccess(t("Grupaj No Kaydedildi"));
            } else if (field === 'chassis' && !chassisNo && grupajNo) {
                setChassisNo(value);
                handleExit(value, grupajNo);
            }
        }
    };

    return (
        <>
            <Breadcrumb current={t("Şase İle Çıkış")} />
            <Card className="p-3">
                <Row>
                    <Col xs="12" md="8" className="mb-3">
                        <Label className="mb-2 font-semibold">{t("Grupaj No")}</Label>
                        <div className="input-group pill-input-group">
                            <TextBox
                                style={{ width: "100%" }}
                                showClearButton={true}
                                value={grupajNo}
                                onValueChanged={(e) => setGrupajNo(e.value)}
                                onKeyDown={(e) => handleKeyDown(e, 'grupaj')}
                                placeholder={t("Grupaj No Giriniz") + "..."}
                                disabled={isProcessing}
                            />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs="12" md="8" className="mb-3">
                        <Label className="mb-2 font-semibold">{t("Şase No")}</Label>
                        <div className="input-group pill-input-group">
                            <TextBox
                                style={{ width: "100%" }}
                                showClearButton={true}
                                value={chassisNo}
                                onValueChanged={(e) => setChassisNo(e.value)}
                                onKeyDown={(e) => handleKeyDown(e, 'chassis')}
                                placeholder={t("Şase No Giriniz")}
                                disabled={isProcessing}
                            />
                        </div>
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col xs="12" md="5">
                        <Button
                            color="success"
                            className="mt-2 mt-md-0 w-100"
                            onClick={() => handleExit()}
                            disabled={isProcessing || !grupajNo || !chassisNo}
                        >
                            {isProcessing ? (
                                <>
                                    <i className="fa fa-spinner fa-spin"></i> &nbsp;
                                    {t("İşleniyor...")}
                                </>
                            ) : (
                                <>
                                    <i className="fa fa-check"></i> &nbsp;
                                    {t("OK")}
                                </>
                            )}
                        </Button>
                    </Col>
                </Row>
            </Card>
        </>
    );
};

// GroupageExit Component
export const GroupageExit = () => {
    const { t } = useFormatMessage();
    const [grupajNo, setGrupajNo] = useState("");
    const [isProcessing, setIsProcessing] = useState(false);

    const handleBarcodeScanned = (scannedValue) => {
        setIsProcessing(true);
        setGrupajNo(scannedValue);
        handleExit(scannedValue);
        setIsProcessing(false);
    };

    useBarcodeScanner(handleBarcodeScanned);

    const handleExit = async (barcode = grupajNo) => {
        if (!barcode.trim()) return;

        setIsProcessing(true);
        try {
            const response = await exitWithGroupage(barcode);
            if (response.success) {
                showSuccess(t("Grupaj çıkışı başarıyla yapıldı"));
                setGrupajNo("");
            } else {
                showError(t(response.error || "İşlem başarısız"));
            }
        } catch (error) {
            let message = error.response?.data?.error || "İşlem sırasında bir hata oluştu";
            showError("Hata" + message);
        } finally {
            setIsProcessing(false);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && grupajNo.trim()) {
            handleExit();
        }
    };

    return (
        <>
            <Breadcrumb current={t("Grupaj İle Çıkış")} />
            <Card className="p-4">
                <Row>
                    <Col md="6">
                        <Label className="mb-2 font-semibold">{t("Grupaj No")}</Label>
                        <TextBox
                            className="w-full"
                            showClearButton={true}
                            value={grupajNo}
                            onValueChanged={(e) => setGrupajNo(e.value)}
                            onKeyDown={handleKeyDown}
                            placeholder={t("Grupaj No Giriniz")}
                            disabled={isProcessing}
                        />
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Button
                        color="success"
                        className="ml-2 w-50"
                        onClick={() => handleExit()}
                        disabled={isProcessing || !grupajNo}
                    >
                        {isProcessing ? (
                            <>
                                <i className="fa fa-spinner fa-spin"></i> &nbsp;
                                {t("İşleniyor...")}
                            </>
                        ) : (
                            <>
                                <i className="fa fa-check"></i> &nbsp;
                                {t("Tamam")}
                            </>
                        )}
                    </Button>
                </Row>
            </Card>
        </>
    );
};

// BayiIade Component
export const BayiIade = () => {
    const { t } = useFormatMessage();
    const [chassisNo, setChassisNo] = useState("");
    const [isProcessing, setIsProcessing] = useState(false);

    const handleBarcodeScanned = (scannedValue) => {
        setIsProcessing(true);
        setChassisNo(scannedValue);
        handleEntry(scannedValue);
        setIsProcessing(false);
    };

    useBarcodeScanner(handleBarcodeScanned);

    const handleEntry = async (chassis = chassisNo) => {
        if (!chassis.trim()) return;

        setIsProcessing(true);
        try {
            const response = await processDealerReturn(chassis);
            if (response.success) {
                showSuccess(t("İade girişi başarıyla yapıldı"));
                setChassisNo("");
            } else {
                showError(t(response.error || "İşlem başarısız"));
            }
        } catch (error) {
            let message = error.response?.data?.error || "İşlem sırasında bir hata oluştu";
            showError("Hata" + message);
        } finally {
            setIsProcessing(false);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && chassisNo.trim()) {
            handleEntry();
        }
    };

    return (
        <>
            <Breadcrumb current={t("Bayi İade")} depo={true} />
            <Card className="p-4">
                <Row>
                    <Col md="6">
                        <Label className="mb-2 font-semibold">{t("Şase No")}</Label>
                        <TextBox
                            className="w-full"
                            showClearButton={true}
                            value={chassisNo}
                            onValueChanged={(e) => setChassisNo(e.value)}
                            onKeyDown={handleKeyDown}
                            placeholder={t("Şase No Giriniz")}
                            disabled={isProcessing}
                        />
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Button
                        color="success"
                        className="ml-2 w-50"
                        onClick={() => handleEntry()}
                        disabled={isProcessing || !chassisNo}
                    >
                        {isProcessing ? (
                            <>
                                <i className="fa fa-spinner fa-spin"></i> &nbsp;
                                {t("İşleniyor...")}
                            </>
                        ) : (
                            <>
                                <i className="fa fa-check"></i> &nbsp;
                                {t("Tamam")}
                            </>
                        )}
                    </Button>
                </Row>
            </Card>
        </>
    );
};

export default {
    TruckApproval,
    GroupageExit,
    ChassisExit,
    BayiIade
};